





















/* eslint-disable @typescript-eslint/camelcase */
import Vue from "vue";
import ResizeObserver from "resize-observer-polyfill";
// @ts-ignore
import echarts from "echarts";
import { axios } from "../../plugins";
const Color = ["#40E0D0", "#2860C7", "#D14743", "#F6B344"];
const LineConfig = {
  tooltip: {
    trigger: "axis"
  },
  grid: {
    left: 0,
    right: 20,
    top: 10,
    bottom: 10,
    containLabel: true
  },
  xAxis: {
    type: "time",
    axisTick: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: "rgba(207,207,207,1)"
      }
    },
    axisLabel: {
      color: "rgb(0,0,0)"
    }
  },
  yAxis: {
    type: "value",
    boundaryGap: false,
    axisTick: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      color: "rgba(99,102,107,1)"
    },
    splitLine: {
      lineStyle: {
        color: "rgba(233,233,233,1)",
        type: "dashed"
      }
    }
  },
  color: Color,
  series: []
};

const LegendMap: any = {
  cluster_total_memory: "总内存",
  cluster_allocatable_memory: "总使用内存",
  cluster_pod_memory_usage: "pod使用内存",
  cluster_load1: "1分钟负载",
  cluster_load5: "5分钟负载",
  cluster_load15: "15分钟负载",
  node_load1: "1分钟负载",
  node_load5: "5分钟负载",
  node_load15: "15分钟负载",
  cluster_disk_read_throughput: "读",
  cluster_disk_write_throughput: "写",
  cluster_disk_read_iops: "读",
  cluster_disk_write_iops: "写",
  cluster_pod_abnormal_count: "异常Pod",
  cluster_pod_count: "调度完成Pod",
  cluster_pod_running_count: "运行中Pod",
  cluster_disk_size_usage: "使用量",
  cluster_disk_size_capacity: "总容量",
  cluster_disk_size_available: "可用容量",
  etcd_network_client_grpc_received_bytes: "接收",
  etcd_network_client_grpc_sent_bytes: "发送",
  etcd_grpc_server_msg_received_rate: "接收",
  etcd_grpc_server_msg_sent_rate: "发送",
  etcd_server_proposals_failed_rate: "提议失败率",
  etcd_server_proposals_applied_rate: "提议应用率",
  etcd_server_proposals_committed_rate: "提议提交率",
  etcd_server_proposals_pending_count: "提议排队率"
};

export default Vue.extend({
  name: "StatusLine",
  props: {
    title: { type: String },
    legend: { type: Boolean, default: false },
    type: { type: String },
    start: { type: Date },
    end: { type: Date },
    step: { type: String },
    format: { type: Function },
    groupBy: { type: Function }
  },
  data() {
    return {
      loading: false,
      chart: null as any,
      observer: (null as any) as ResizeObserver,
      timer: 0,
      legendArr: [] as string[],
      Color
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(LineConfig);
      // 监听 chart 变化
      this.observer = new ResizeObserver(() => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.chart.resize();
        }, 200);
      });
      this.observer.observe(this.$refs.chart as HTMLElement);
    },
    getData() {
      this.loading = true;
      axios
        .get(
          `/metrics/prom/api/v1/query_range?query=${
            this.type
          }&start=${this.getTime(this.start as any)}&end=${this.getTime(
            this.end as any
          )}&step=${this.step}`
        )
        .then(res => {
          if (res.data.data.result.length === 0) {
            // 无数据补0
            let step = 60 * 1000;

            switch (this.step) {
              case "1m":
                step = 60 * 1000;
                break;
              case "10m":
                step = 10 * 60 * 1000;
                break;
              case "30m":
                step = 30 * 60 * 1000;
                break;
              case "1h":
                step = 60 * 60 * 1000;
                break;
              case "24h":
                step = 24 * 60 * 60 * 1000;
                break;
            }
            let start = parseInt(this.getTime(this.start as any)) * 1000;
            const end = parseInt(this.getTime(this.end as any)) * 1000;
            const data = [];
            while (start < end) {
              data.push([start, 0]);
              start += step;
            }
            return [data];
          }
          this.legendArr = [];
          return res.data.data.result.map((result: any) => {
            if (this.groupBy) {
              this.legendArr.push(this.groupBy(result.metric));
            } else {
              this.legendArr.push(LegendMap[result.metric.__name__] || "");
            }
            return (result.values as any[]).map((item: [number, string]) => {
              return [
                item[0] * 1000,
                this.format ? this.format(item[1]) : item[1]
              ];
            });
          });
        })
        .then(data => {
          if (data.length === 0) {
            this.chart.clear();
            this.chart.setOption(LineConfig);
          } else {
            this.chart.setOption({
              series: [
                ...data.map((d: any[], index: number) => {
                  return {
                    name: this.legendArr[index],
                    type: "line",
                    smooth: 0.6,
                    showSymbol: false,
                    lineStyle: {
                      width: 2
                    },
                    data: d
                  };
                })
              ]
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTime(date: Date) {
      return (date.getTime() / 1000).toFixed(0);
    }
  }
});
